import { render, staticRenderFns } from "./MemberManagementPerformanceTargets.vue?vue&type=template&id=4b1df3cb"
import script from "./MemberManagementPerformanceTargets.vue?vue&type=script&lang=js"
export * from "./MemberManagementPerformanceTargets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports